// extracted by mini-css-extract-plugin
export default {"imageWrapper":"nO-z","hovered":"oO-z","hoverImage":"pO-z","mainImage":"qO-z","imageNoBackground":"rO-z","fullSizeImage":"sO-z"};